import { getActBaseConfig } from '@/config';
import { useStampStore } from '@/store/stamp';
import { UserStatus } from '@/types';
import { updateDonationErrTimes } from '@/utils';
import { computed, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';

// 配置
const actBaseConf = getActBaseConfig();

// 放在外面全局共享
const donationErrTimes = ref(0); // 捐赠错误次数

export function useDonation() {
  const stampStore = useStampStore(); // store
  const { userStampInfo, globalActInfo } = storeToRefs(stampStore);
  const userStampInfoVal = computed(() => userStampInfo.value); // 个人印花信息
  const globalActInfoVal = computed(() => globalActInfo.value); // 总活动信息

  // 设置捐赠失败次数
  const setDonationErrTimes = (num: number) => {
    updateDonationErrTimes(num);
    donationErrTimes.value = num;
  };

  // 失败捐赠次数超过上限(上限为捐赠次数上线)
  const isOverDonationErrLimit = computed(() => donationErrTimes.value >= actBaseConf.donationLimit);

  // 用户当前捐贈状态
  const userDonationStatus = computed(() => {
    const { intervalTotalCnt, intervalUsedCnt } = userStampInfoVal.value;
    const { daySent, dayLimit } = globalActInfoVal.value;
    return getUserDonationStatus({
      intervalTotalCnt,
      intervalUsedCnt,
      daySent,
      dayLimit,
    });
  });
  return {
    userDonationStatus,

    // 设置捐赠失败次数
    setDonationErrTimes,
    // 失败捐赠次数超过上限(上限为捐赠次数上线)
    isOverDonationErrLimit,
  };
}

/**
 * 获取用户捐赠状态
 * @param intervalTotalCnt 用户今日获得印花数
 * @param intervalUsedCnt 用户今日使用印花数
 * @param daySent 当日总捐赠数据
 * @param dayLimit 当日总捐赠限额
 * @returns
 */
function getUserDonationStatus({ intervalTotalCnt, intervalUsedCnt, daySent, dayLimit }): UserStatus {
  // return UserStatus.isNoQuota;
  // 拉取配置
  const actBaseConfig = getActBaseConfig();
  const { donationLimit, isMoreDonation } = actBaseConfig;
  // isDonated > isNoQuota > canMoreDonate > canDonate > isNoStamp
  // 用户当日已获得印花
  if (intervalTotalCnt > 0) {
    // 捐赠超过限制 or 获得的印花已经全部捐赠
    if (intervalUsedCnt >= donationLimit || intervalUsedCnt >= intervalTotalCnt) {
      // 用户当日已捐贈
      return UserStatus.isDonated;
    }
    // 还未达到目标
    if (daySent < dayLimit) {
      // 需要展示加码 and 曾经捐赠过
      if (isMoreDonation && intervalUsedCnt > 0) {
        return UserStatus.canMoreDonate;
      }
      // 用户当日已获得印花可捐赠
      return UserStatus.canDonate;
    }
  }
  if (daySent >= dayLimit) {
    // 当日捐贈目标已经达成
    return UserStatus.isNoQuota;
  }
  // 用户当日未获得印花
  return UserStatus.isNoStamp;
}
